import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var LockIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 20 24",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9431 8.47009V7.05814C16.9431 3.16671 13.776 0 9.88348 0C5.99094 0 2.8239 3.16704 2.8239 7.05814V8.47009C1.26431 8.47009 0 9.73436 0 11.294V21.1761C0.00140623 22.7357 1.26568 24 2.8239 24H16.942C18.5016 24 19.7659 22.7357 19.7659 21.1761V11.294C19.7659 9.7344 18.5012 8.47009 16.9431 8.47009ZM5.64752 7.05814C5.64752 4.72224 7.54744 2.82217 9.88348 2.82217C12.2195 2.82217 14.1194 4.72209 14.1194 7.05814V8.47009H5.64788L5.64752 7.05814ZM11.2955 16.9417C11.2955 17.7208 10.664 18.3536 9.88351 18.3536C9.1044 18.3536 8.47156 17.7222 8.47156 16.9417V14.1178C8.47156 13.3387 9.1044 12.7058 9.88351 12.7058C10.6626 12.7058 11.2955 13.3373 11.2955 14.1178V16.9417Z"
  }));
});
LockIcon.displayName = 'LockIcon';
export default LockIcon;